import React from 'react';
import { SearchBox } from '@fluentui/react-search';
import {
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  searchBox: {
    minWidth: '300px',
    '& input[type="search"]': {
      backgroundImage: 'none',
      backgroundSize: 'unset',
      paddingLeft: '4px',
    },
    '& input[type="search"]::placeholder ': {
      color: '#707070',
    },
  },
});

export const SearchBoxFilter = (props) => {
  const {
    i18n,
    className,
    onSearchTextChanging,
    onSearchTextChange,
    onSearchTextBlur,
    onSearchTextClear,
    defaultSearchText,
    searchboxPlaceHolder,
    autoFocus,
    ariaLabel,
  } = props;

  const classes = useStyles();

  return (
    <div className={className}>
      <SearchBox
        autoFocus={autoFocus}
        className={mergeClasses('search-box', classes.searchBox)}
        aria-label={ariaLabel || ''}
        placeholder={searchboxPlaceHolder || i18n.getString(_TL_('Search by asset and folder name or ID'))}
        defaultValue={defaultSearchText}
        onChange={(e, data) => {
          if (data.value === '' && e.type === 'click') {
            onSearchTextClear(data);
          } else {
            onSearchTextChanging(e, data.value);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onSearchTextChange(e.target.value);
          }
        }}
        onBlur={() => {
          onSearchTextBlur();
        }}
      />
    </div>
  );
};
